'use strict'

export const MGT_TASK_CANCEL_REASON_OPTIONS = [
  'Отсутствует возможность выполнить работы.', // is default
  'По координатам, указанным в задаче ПТК АПТС, объект отсутствует.'
]
